import { useContext, useEffect, useMemo, useRef, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callautopopulate } from "../../../services/callautopop";
import { DateObject } from "react-multi-date-picker";
import { useCommon } from "../../Common/useCommon";

export const useProjectAccessRequestList = () => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { getValuePermission } = useCommon();
    const [loader, setLoader] = useState(false);
    const tagRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [showRequestPopup, setShowRequestPopup] = useState(false)
    const [filterValues, setFilterValues] = useState({ hoveredRange: [new DateObject().subtract(8, "days"), new DateObject().add(0, "days"),] });
    const [dropDownOption, setDropDownOption] = useState({});
    const [editData, setEditData] = useState({});
    const [showApprovePopup, setShowApprovePopup] = useState(false);
    const [approval, setApproval] = useState({
        status: '',
        expiry_date: null,
        selectedRadio: ""
    });
    const [headerChecked, setHeaderChecked] = useState(false);


    useEffect(() => {
        callautopopulate("request_status", "all_users", "projects", "user_info", "project_roles", "project_request_type").then((res) => {
            setDropDownOption({
                statusOptions: res?.request_status,
                users: _.sortBy(res?.all_users, "user_display_name"),
                projects: res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)),
                userCode: res?.user_info?.[0]?.user_code,
                requestType: res?.project_request_type,
                projectRoleOption: res?.project_roles,
                apiCall: true
            })
            setFilterValues((prev) => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })

    }, [])

    const columnDefs = [
        // {
        //     field: "checkbox",
        //     headerName: "",
        //     headerComponent: () => {
        //         return (
        //             <div className="w100">
        //                 <input type="checkbox" onChange={(e) => { handleSelectAll(e) }} checked={headerChecked} />
        //             </div>
        //         )
        //     },
        //     width: 40,
        //     hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
        //     cellStyle: { textAlign: "center" },
        //     suppressHeaderMenuButton: true,
        //     cellRenderer: (params) => {
        //         const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
        //         return (
        //             <div>
        //                 {
        //                     (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) && <input type="checkbox" checked={params.data.is_checked} onChange={(e) => handleSelectAll(e, params)} />
        //                 }

        //             </div>
        //         )
        //     }
        // },
        {
            field: "edit",
            headerName: "Edit",
            width: 50,
            cellStyle: { textAlign: "center" },
            headerClass: "ag-text-center",
            hide: filterValues?.status?.request_status_id !== _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellRenderer: (params) => {
                return (
                    <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => { setShowRequestPopup(true); setEditData(params) }} /></div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Status",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id;
                const rejectedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_rejected" })?.request_status_id;
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const grantId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_grant" })?.request_status_id;
                const partialId = -1;
                return (
                    <div style={{ cursor: "pointer", fontSize: "large" }}>
                        {params.data.request_status_id === approveId && <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "green" }} />}
                        {params.data.request_status_id === rejectedId && <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "red" }} />}
                        {params.data.request_status_id === pendingId && <FontAwesomeIcon icon="fa-solid fa-clock" style={{ color: "#d4d404" }} />}
                        {params.data.request_status_id === partialId && <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: "green" }} />}
                        {params.data.request_status_id === grantId && <FontAwesomeIcon icon="fa-solid fa-check-double" style={{ color: "green" }} />}
                    </div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Action",
            width: 150,
            cellStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        onChange={(e) => { setShowApprovePopup(true); setApproval((prevState) => ({ ...prevState, data: params?.data, status: e.target.value, expiry_date: new Date(params?.data?.expiry_datetime), exp_days: _.find(dropDownOption?.projectRoleOption, { project_role_id: params?.data?.project_role_id })?.exp_days })) }
                                        }
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        onChange={(e) => { handleRequest(e.target.value, params?.data) }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        { headerName: "Project Name", field: "project_name", width: 140, headerClass: "help-desk-grid-header" },
        { headerName: "Project Role", field: "project_role_name", width: 150, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header" },
        { headerName: "Requested For", field: "requested_user_name", width: 100, headerClass: "help-desk-grid-header" },
        { headerName: "Requested by", field: "requested_by_user_name", width: 100, headerClass: "help-desk-grid-header" },

        { headerName: "Request Type", field: "request_type_name", width: 90, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header" },
        {
            headerName: "Is Billable", field: "is_billable", width: 70, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                return (
                    <div>{params?.data?.is_billable && <FontAwesomeIcon icon="fa-solid fa-circle-check" />}</div>
                )
            }
        },
        { headerName: "Requested To", field: "approver_user_name", width: 100, headerClass: "help-desk-grid-header" },
        {
            headerName: "Expiry Date", field: "expiry_datetime", width: 140, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.expiry_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Requested Date", field: "modified_datetime", width: 140, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.modified_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Approve Date",
            field: "approve_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.approve_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
    ];





    useEffect(() => {
        dropDownOption?.apiCall && filterValues?.apiCall && getRequestedData();
    }, [dropDownOption?.apiCall, filterValues?.apiCall])

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value),
        });
        setFilterValues((prev) => ({ ...prev, status: data }));
        getRequestedData(parseInt(e.target.value))
    };


    const getRequestedData = async (status) => {
        try {
            setRowData([]);
            setLoader(true);
            const payload = {
                "project_ids": _.pluck(filterValues?.projects, "project_id").toString(),
                "request_status_id": status ? status : filterValues?.status?.request_status_id,
                "from_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : '',
                "to_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : '',
                "users": _.pluck(filterValues?.all_users, "user_code").toString(),
                "project_role_ids": _.pluck(filterValues?.project_role, "project_role_id").toString(),
                "request_type_ids": _.pluck(filterValues?.project_request_type, "request_type_id").toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTREQUESTDETAIL"), payload);
            if (res?.StatusCode === 202 || res?.status === 202) {
                showError("Error", res.body.errorMessage);
                setLoader(false);
            } else if (res.body.data) {
                setLoader(false);
                setRowData(_.sortBy(_.uniq(res.body.data.project_list, (item) => item.project_role_request_id), "requested_user_name"));
            }
            setFilterValues((prev) => ({ ...prev, isApiCall: false, apiCall: false }))
        } catch (error) {
            setLoader(false);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader(false);
        }
    }

    const handleSelectAll = (e, rowdata) => {
        const data = [...rowData];
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = e?.target?.checked;
            setRowData(data);
        } else {
            data.forEach((item) => {
                if (item.approver_user_code === dropDownOption?.userCode) {
                    item.is_checked = e?.target?.checked;;
                }
            });
            setHeaderChecked(!headerChecked)
            setRowData(data);
        }
    }

    // handle the project approve & reject request 
    const handleRequest = async (status, data) => {

        try {
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: status || approval.status })
            const payload = {
                "project_role_request_ids": data?.project_role_request_id?.toString(),
                "request_status_id": requestStatus.request_status_id,
                "expiry_datetime": dateConvert(approval?.expiry_date, "iso-string") || "",
                "is_atlassian": data?.is_atlassian,
                "project_id": data?.project_id,
                "product_project_id": data?.product_project_id,
                "project_key": data?.project_key,
                "component_id": data?.component_id || 0,
                "atlassian_product_id": data?.product_accountId || 0,
                "project_user_code": data?.requested_user_code,
                "project_role_id": data?.project_role_id
            }

            const res = await services.getInvokeRemote("POST", Urls("APPROVEPROJECTREQUESTUPSERT"), payload)
            if (res.body.data) {
                showSuccess('Success', res.body.message)
                getRequestedData()
                setApproval((prevState) => ({ ...prevState, status: '', expiry_date: null, exp_days: null }))
                setShowApprovePopup(false)
            }
            else {
                showError("Error", res.body.errorMessage);
            }

        } catch (error) {
            console.error("Error", error);

            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, editData, setEditData, handleRequest, showInfo, approval, setApproval, showApprovePopup, setShowApprovePopup
    }), [loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, editData, setEditData, handleRequest, showInfo, approval, setApproval, showApprovePopup, setShowApprovePopup]);
}